import { useState } from 'react';
import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  const [imgErrors, setImgErrors] = useState<Record<number, boolean>>({});

  const handleImgError = (idx: number) => {
    setImgErrors((prev) => ({ ...prev, [idx]: true }));
  };

  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
            深度报道
          </h2>
          <p className="text-sm text-foreground-500">行业揭秘与独家调查，好内容值得细品</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative w-full aspect-[8/5] bg-background-200 overflow-hidden">
                {!imgErrors[i] ? (
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={() => handleImgError(i)}
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <i className="ri-image-line text-4xl text-background-400"></i>
                  </div>
                )}
                <div className="absolute top-3 left-3">
                  <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold text-white ${item.tagColor}`}>
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="font-heading text-sm text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 flex-1 line-clamp-2">
                  {item.desc}
                </p>
                <span className="text-[11px] text-foreground-400">{item.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}